import React from 'react';

const CustomAlgorithmSection = () => {
  return (
    <section className="py-24 bg-surface-container-lowest/80 backdrop-blur-md overflow-hidden reveal-on-scroll">
      <div className="max-w-container-max mx-auto px-margin-mobile md:px-margin-desktop grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
        <div className="relative">
          <div className="absolute -top-10 -left-10 w-40 h-40 bg-primary/20 blur-[100px] rounded-full"></div>
          <div className="text-primary font-bold text-[14px] uppercase tracking-[4px] mb-4">Premium Service</div>
          <h2 className="font-display-lg text-headline-md md:text-[48px] mb-6">Need a <span className="text-primary">Custom Trading Algorithm?</span></h2>
          <p className="text-on-surface-variant font-body-lg mb-10">Turn your trading strategy into a fully automated MT4 or MT5 Expert Advisor. We build professional, optimized, and secure custom algorithms customized to your exact requirements.</p>
          <div className="flex flex-wrap gap-4 mb-10">
            <button className="bg-primary text-on-primary font-bold px-8 py-4 rounded-lg flex items-center space-x-2 hover:shadow-[0_0_20px_rgba(240,185,11,0.3)] transition-all btn-shimmer">
              <span>Request Custom EA</span>
              <span className="material-symbols-outlined">bolt</span>
            </button>
            <button className="flex items-center space-x-3 px-8 py-4 text-silver-text hover:text-secondary transition-all">
              <div className="w-6 h-6 rounded-full bg-secondary flex items-center justify-center">
                <span className="material-symbols-outlined text-white text-[16px]">chat</span>
              </div>
              <span className="font-bold">Talk on WhatsApp</span>
            </button>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-gutter-desktop">
          <div className="p-8 rounded-xl bg-surface-container-low border border-white/5 hover:border-primary/20 transition-all stagger-item">
            <span className="material-symbols-outlined text-primary mb-4">smart_toy</span>
            <h4 className="font-bold text-silver-text mb-2">Strategy to Automation</h4>
            <p className="text-on-surface-variant text-[14px]">Convert your manual trading rules into an automated EA with 100% precision.</p>
          </div>
          <div className="p-8 rounded-xl bg-surface-container-low border border-white/5 hover:border-primary/20 transition-all stagger-item">
            <span className="material-symbols-outlined text-primary mb-4">terminal</span>
            <h4 className="font-bold text-silver-text mb-2">MT4 &amp; MT5 Development</h4>
            <p className="text-on-surface-variant text-[14px]">Professional Expert Advisor development for both MetaTrader platforms.</p>
          </div>
          <div className="p-8 rounded-xl bg-surface-container-low border border-white/5 hover:border-primary/20 transition-all stagger-item">
            <span className="material-symbols-outlined text-primary mb-4">verified</span>
            <h4 className="font-bold text-silver-text mb-2">Prop Firm Compatible</h4>
            <p className="text-on-surface-variant text-[14px]">Build algorithms designed for funded account requirements and drawdowns.</p>
          </div>
          <div className="p-8 rounded-xl bg-surface-container-low border border-white/5 hover:border-primary/20 transition-all stagger-item">
            <span className="material-symbols-outlined text-primary mb-4">support_agent</span>
            <h4 className="font-bold text-silver-text mb-2">Ongoing Support</h4>
            <p className="text-on-surface-variant text-[14px]">Optimization, improvements, and future upgrades available for your custom bot.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomAlgorithmSection;
